import {
  Component,
  Input,
  Signal,
  WritableSignal,
  computed,
  signal,
} from "@angular/core";

import { FeedIssue, FeedIssueType } from "@core/api-models/feeds.models";

@Component({
  selector: "ngx-feed-status-issue",
  templateUrl: "./feed-status-issue.component.html",
  standalone: false,
})
export class FeedStatusIssueComponent {
  _type: "warning" | "error" = "error";
  @Input() set type(to: "warning" | "error") {
    this._type = to;
    this.errorWhiteList = [
      { name: "id", size: 1 / 4 },
      { name: "title", size: 1 / 2 },
    ];
  }

  _issues: FeedIssueType;
  @Input() set issues(to: FeedIssueType) {
    this._issues = to;
    this.errors.update(() => to.errors ?? []);
  }
  errorWhiteList: { name: string; size: number }[] = [
    { name: "id", size: 1 / 4 },
    { name: "title", size: 1 / 2 },
  ];

  errors: WritableSignal<FeedIssue[]> = signal([]);

  errorsFiltered: Signal<
    (FeedIssue & { header: { name: string; size: number }[] })[]
  > = computed(() => {
    return this.errors().map((error) => {
      const err = JSON.parse(JSON.stringify(error));
      const products = err.products
        .filter((product, i) => i < 5)
        .map((product) => {
          const filtered = {};
          this.errorWhiteList.forEach((item) => {
            filtered[item.name] = product[item.name];
          });
          filtered[err.field] = product[err.field];
          return filtered;
        });
      err.products = products;
      err.header = JSON.parse(JSON.stringify(this.errorWhiteList));
      err.header.push({ name: err.field, size: 1 / 4 });
      return err;
    });
  });
}
